/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Agent_PriorityInputs */

const en_us2_prescription_reason_agent_priority = /** @type {(inputs: Prescription_Reason_Agent_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer chose it for a muscle you prioritised`)
};

const pt_br2_prescription_reason_agent_priority = /** @type {(inputs: Prescription_Reason_Agent_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu personal escolheu para um músculo que você priorizou`)
};

const es_419_prescription_reason_agent_priority = /** @type {(inputs: Prescription_Reason_Agent_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador lo eligió para un músculo que priorizaste`)
};

const pt_pt2_prescription_reason_agent_priority = /** @type {(inputs: Prescription_Reason_Agent_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treinador escolheu-o para um músculo que priorizaste`)
};

const fr_fr2_prescription_reason_agent_priority = /** @type {(inputs: Prescription_Reason_Agent_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisi par ton coach pour un muscle que tu as mis en priorité`)
};

const de_de2_prescription_reason_agent_priority = /** @type {(inputs: Prescription_Reason_Agent_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach hat sie für einen Muskel gewählt, den du priorisiert hast`)
};

const it_it2_prescription_reason_agent_priority = /** @type {(inputs: Prescription_Reason_Agent_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo coach l'ha scelto per un muscolo a cui hai dato priorità`)
};

/**
* | output |
* | --- |
* | "Your trainer chose it for a muscle you prioritised" |
*
* @param {Prescription_Reason_Agent_PriorityInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_agent_priority = /** @type {((inputs?: Prescription_Reason_Agent_PriorityInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Agent_PriorityInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_agent_priority(inputs)
	if (locale === "es-419") return es_419_prescription_reason_agent_priority(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_agent_priority(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_agent_priority(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_agent_priority(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_agent_priority(inputs)
	return en_us2_prescription_reason_agent_priority(inputs)
});
export { prescription_reason_agent_priority as "prescription.reason.agent_priority" }